import {DataListContainerDefProps} from "../DataListContainer/defProps";

export const detailsSummaryStr = 'Details Summary';
export const NDropDownDetailsDefProps = {
  detailsSummary: detailsSummaryStr,
  detailsOptions: DataListContainerDefProps.itemsList
};